module.exports = __webpack_public_path__ + "media/images/icons/instagram_footer-6d32ae57aebae67e9adcf5303c1fa23a.svg";